<template>
    <q-btn-dropdown
        v-bind="$attrs"
        no-caps
        :color="color"
        :label="label"
        size="sm"
        :data-component-name="$options.name"
    >
        <q-list>
            <q-item>
                <q-item-section>
                    <Input
                        placeholder="filtrer"
                        v-model="searchText"
                        value=""
                    />
                    <!-- <q-item-label>Photos</q-item-label> -->
                </q-item-section>
            </q-item>

            <q-item 
                clickable
                v-close-popup
                v-for="(option, index) in optionsList"
                v-bind:key="index"
                @click="$emit('input', option)"
            >
                <q-item-section>
                    <q-item-label>{{ option.name }}</q-item-label>
                </q-item-section>
            </q-item>

        </q-list>
    </q-btn-dropdown>
</template>

<script>
    import QBtnDropdown from 'quasar'
    export default {
        name: 'DropdownButton',
        extends: QBtnDropdown,
        props: {
            outlined: {
                type: Boolean,
                default: false
            },
            dense: {
                type: Boolean,
                default: true
            },
            filled: {
                type: Boolean,
                default: true
            },
            options: {
                type: Array,
                default(){ return new Array() }
            },
            value: String,
            label: {
                type: String,
                default: 'Button'
            },
            color: {
                type: String,
                default: 'primary'
            },
        },
        data(){
            return {
                searchText: ''
            }
        },
        mounted(){
        },
        computed: {
            optionsList(){
                let optionsList=[];
                if(!this.searchText) optionsList=Object.assign([], this.options);
                if(this.options){
                    this.options.forEach(function(option){
                        if(this.searchText=='' || (option.name.toLowerCase().search(this.searchText.toLowerCase()) !== -1)){
                            optionsList.push(option);
                        }

                    }.bind(this))
                }
                return optionsList;
            }
        }
    }
</script>